import icon from '../../../../../frontend/phi3d/src/assets/img/SVG_icons/inset_fs.svg';
import { SettingsEntry } from '../settings-entry';
import { img } from '@phi/components';
import FormToggle from '@frontend/components/FormToggle';
import app from '@frontend/application-container';
import { h } from 'vue';

export function ExpandedLayout() {
    return SettingsEntry(
        'Expanded layout',

        'Toggle between inset and expanded layout.',

        img(icon, 'Toggle between inset and expanded layout'),

        h(FormToggle, {
            value: !(app.settings.inset),
            'onUpdate:value': x => app.settings.inset = !x,
        }),
    );
}
